import { BASE_URL, COOKIE_REMEMBER_ME } from "@/constants";
import { useNotificationStore } from "@/states/zustand/notification";
import { useUserStore } from "@/states/zustand/user";
import axios from "axios";
import Cookies from "js-cookie";
import { createApi } from "./api";
import { getJwtToken } from "./getJWT";

export const axiosClient = axios.create({
    baseURL: BASE_URL,
    maxRate: 3,
    timeout: 30000, // 30 second
});

axiosClient.interceptors.request.use(
    (config) => {
        const { jwt } = getJwtToken();
        config.headers["ngrok-skip-browser-warning"] = "69420";

        if (jwt && "token" in jwt) {
            config.headers["Authorization"] = `Bearer ${jwt.token}`;
        };

        return config;
    }
)

const AUTH_ROUTES = [
    "/auth/admin/login",
    "/auth/user/refreshToken",
]

axiosClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        const isAuthRoutes = AUTH_ROUTES.some(route => originalRequest.url?.includes(route));
        const rememberMe = Cookies.get(COOKIE_REMEMBER_ME) === "true";

        if (error?.status === 401 && !isAuthRoutes && !originalRequest._retry) {

            originalRequest._retry = true;

            const { jwt, setJwtToken, removeJwtToken } = getJwtToken();

            if (rememberMe) {
                if (jwt && jwt?.refreshToken) {
                    try {
                        const newJwt = await CLIENT_API.refreshToken(jwt.refreshToken);
                        setJwtToken(newJwt);
                        useUserStore.getState().setJwt(newJwt);
                        originalRequest.headers["Authorization"] = `Bearer ${newJwt.token}`;
                        return axiosClient(originalRequest);
                    } catch (refreshError) {
                        console.log(refreshError);
                        removeJwtToken();
                        useUserStore.getState().clearJwt();
                        useNotificationStore.getState().setNotification({
                            type: "error",
                            message: "Failed to fetch refresh token. Please login again!"
                        })
                    }
                } else {
                    removeJwtToken();
                    useUserStore.getState().clearJwt();
                }
            } else {
                useNotificationStore.getState().setNotification({
                    type: "warning",
                    message: "You haven't checked the remember me. Please login again!"
                })
                removeJwtToken();
                useUserStore.getState().clearJwt();
            }
        }

        return Promise.reject(error);
    }
);

export const CLIENT_API = createApi(axiosClient);